<template>
  <div class="inner_menu">
    <b-list-group>
      <router-link
        v-for="menu in DetailMenus"
        :key="menu.id"
        :to="menu.link.replace('{id}', id).replace('{maId}', id).replace('{maName}', maName)"
        class="list-group-item list-group-item-action menu_li"
        :class="{ active: menu.id === activeItem }"
        @click.native="setActive(menu.id)"
      >
        <b-icon :icon="menu.icon"></b-icon> {{ menu.label }}
      </router-link>

      <!-- <b-link v-for="menu in DetailMenus" :key="menu.id" :active="menu.id === activeItem" style="border: none;"
        @click="setActive(menu.id)" tag="b-link" class="menu_li" :href="menu.link.replace('{id}', id)">
        <b-icon :icon="menu.icon"></b-icon> {{
          menu.label
        }}
      </b-link> -->
    </b-list-group>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        // activeItem: '',
        // DetailMenus: [
        //   { id: 'thong_tin_chung', label: 'Thông tin chung', icon: 'person-lines-fill', link: '/customer-support/account/{id}' },
        //   { id: 'lich_su_gan', label: 'Lịch sử gán NV', icon: 'list-check', link: '/customer-support/account/{id}/history-assign' },
        // ],
      }
    },
    props: {
      activeItem: String,
      DetailMenus: Array,
      id: String,
      maId: String,
      maName: String,
      taskId: String,
      taskName: String,
      storeId: String,
      storeName: String,
      moId: String,
      moName: String,
    },
    methods: {
      setActive(id) {
        this.activeItem = id
      },
    },
  }
</script>
<style scoped>
  .inner_menu {
    border-right: 1px solid #edf1fa;
  }

  .menu_li {
    border: none;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }
</style>
